import cx from 'classnames';
import { getScaleNotes, shouldHighlightKey, generatePianoKeys, getChordKeyIndices } from '../../utils/pianoHelpers';

import './PianoScale.scss';

/**
 * Keyboard showing the notes of a key's scale, drawn bare for PianoScalePopup's card.
 *
 * When `activeChord` is set (a chord picked from ScaleChords), that chord's keys stay
 * lit in root position while the rest of the scale steps back, so the chord shape
 * reads against the scale it comes from.
 */
const PianoScale = ({ currentKey, showNoteLabels = false, activeChord = null }) => {
  if (!currentKey) {
    return null;
  }

  const scaleNotes = getScaleNotes(currentKey);
  const pianoKeys = generatePianoKeys(currentKey);
  const chordKeys = getChordKeyIndices(currentKey, activeChord, pianoKeys);

  return (
    <div className="piano-scale">
      <div className="piano-scale__keyboard">
        <div className="piano-scale__keys">
          {pianoKeys.map((key, index) => {
            const isInScale = shouldHighlightKey(key, scaleNotes, pianoKeys, currentKey);
            const isChordTone = chordKeys?.has(index) ?? false;
            // A chord tone can sit above the scale run (the fifth of the VII chord),
            // so it lights up whether or not the scale reaches that far.
            const isHighlighted = isInScale || isChordTone;

            return (
              <div
                key={key.id}
                className={cx('piano-scale__key', {
                  'piano-scale__key--black': key.isBlack,
                  'piano-scale__key--white': !key.isBlack,
                  'piano-scale__key--highlighted': isHighlighted,
                  'piano-scale__key--chord-tone': isChordTone,
                  'piano-scale__key--muted': chordKeys && isHighlighted && !isChordTone,
                })}
                data-note={key.note}
              >
                {showNoteLabels && isHighlighted && <span className="piano-scale__note-label">{key.note}</span>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PianoScale;
